
// @ts-nocheck


export const localeCodes =  [
  "ch_de",
  "ch_fr",
  "ch_it",
  "ch_en",
  "at_de",
  "at_en",
  "de_de",
  "de_en",
  "se_sv",
  "se_en",
  "pl_pl",
  "pl_en"
]

export const localeLoaders = {
  "ch_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "ch_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "ch_it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__vercel_path0_lang_it_json" */), cache: true }],
  "ch_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "at_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "at_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "de_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "de_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "se_sv": [{ key: "../lang/sv.json", load: () => import("../lang/sv.json" /* webpackChunkName: "locale__vercel_path0_lang_sv_json" */), cache: true }],
  "se_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "pl_pl": [{ key: "../lang/pl.json", load: () => import("../lang/pl.json" /* webpackChunkName: "locale__vercel_path0_lang_pl_json" */), cache: true }],
  "pl_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "ch_de",
      "name": "Deutsch (Schweiz)",
      "display": "Deutsch",
      "iso": "de-CH",
      "group": "ch",
      "perfionCulture": "de-DE",
      "shopwareLangId": "0196aefcaad978baa1a22d25a9f0cf82",
      "shopwareAccessKey": "SWSCWNHOBEIWNDUWOGKXEGW0AQ",
      "domain": "wetrok.ch",
      "domainDefault": true,
      "files": [
        "lang/de.json"
      ]
    },
    {
      "code": "ch_fr",
      "name": "Français (Suisse)",
      "display": "Français",
      "iso": "fr-CH",
      "group": "ch",
      "shopwareLangId": "0196af04d70f76e89fc7e0c924024f7e",
      "perfionCulture": "fr-FR",
      "shopwareAccessKey": "SWSCWNHOBEIWNDUWOGKXEGW0AQ",
      "domain": "wetrok.ch",
      "files": [
        "lang/fr.json"
      ]
    },
    {
      "code": "ch_it",
      "name": "Italiano (Svizzera)",
      "display": "Italiano",
      "iso": "it-CH",
      "group": "ch",
      "perfionCulture": "en-US",
      "shopwareLangId": "0196af05544f7d7ab0a7526778268574",
      "shopwareAccessKey": "SWSCWNHOBEIWNDUWOGKXEGW0AQ",
      "domain": "wetrok.ch",
      "files": [
        "lang/it.json"
      ]
    },
    {
      "code": "ch_en",
      "name": "English (Switzerland)",
      "display": "English",
      "iso": "en-US",
      "group": "ch",
      "perfionCulture": "en-US",
      "shopwareLangId": "0196aefaa5d17b01b967c289591d9a78",
      "shopwareAccessKey": "SWSCWNHOBEIWNDUWOGKXEGW0AQ",
      "domain": "wetrok.ch",
      "files": [
        "lang/en.json"
      ]
    },
    {
      "code": "at_de",
      "name": "Deutsch (Österreich)",
      "display": "Deutsch",
      "iso": "de-AT",
      "group": "at",
      "perfionCulture": "de-DE",
      "shopwareLangId": "0196aefd33da79f893a78859a8ec5939",
      "shopwareAccessKey": "SWSCMWDFNTD2EXDKNFZ2UUXXEQ",
      "domain": "wetrok.at",
      "domainDefault": true,
      "files": [
        "lang/de.json"
      ]
    },
    {
      "code": "at_en",
      "name": "English (Austria)",
      "display": "English",
      "iso": "en-US",
      "group": "at",
      "perfionCulture": "en-US",
      "shopwareLangId": "0196aefb8c26710b9bdf2e59925c22c7",
      "shopwareAccessKey": "SWSCMWDFNTD2EXDKNFZ2UUXXEQ",
      "domain": "wetrok.at",
      "files": [
        "lang/en.json"
      ]
    },
    {
      "code": "de_de",
      "name": "Deutsch (Deutschland)",
      "display": "Deutsch",
      "iso": "de-DE",
      "group": "de",
      "shopwareLangId": "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
      "perfionCulture": "de-DE",
      "shopwareAccessKey": "SWSCDZJ5U3HHV2TLZE44UGPNEG",
      "domain": "wetrok.de",
      "domainDefault": true,
      "files": [
        "lang/de.json"
      ]
    },
    {
      "code": "de_en",
      "name": "English (Germany)",
      "display": "English",
      "iso": "en-US",
      "group": "de",
      "perfionCulture": "en-US",
      "shopwareLangId": "0196aefb44f37cb7a41af7abde9419a7",
      "shopwareAccessKey": "SWSCDZJ5U3HHV2TLZE44UGPNEG",
      "domain": "wetrok.de",
      "files": [
        "lang/en.json"
      ]
    },
    {
      "code": "se_sv",
      "name": "Svenska (Sverige)",
      "display": "Svenska",
      "iso": "sv-SE",
      "group": "se",
      "shopwareLangId": "0195cc650fb27124bfc593144c13e9fb",
      "perfionCulture": "en-US",
      "shopwareAccessKey": "SWSCCHLUUNBORFJUTXHOBKV2OA",
      "domain": "wetrok.se",
      "domainDefault": true,
      "files": [
        "lang/sv.json"
      ]
    },
    {
      "code": "se_en",
      "name": "English (Sweden)",
      "display": "English",
      "iso": "en-US",
      "group": "se",
      "shopwareLangId": "0196aefc155c750c9f7f30c63bb3cb44",
      "perfionCulture": "en-US",
      "shopwareAccessKey": "SWSCCHLUUNBORFJUTXHOBKV2OA",
      "domain": "wetrok.se",
      "files": [
        "lang/en.json"
      ]
    },
    {
      "code": "pl_pl",
      "name": "Polski (Polska)",
      "display": "Polski",
      "iso": "pl-PL",
      "group": "pl",
      "perfionCulture": "de-DE",
      "shopwareLangId": "0195cc69c9b1713b829056d4a58bd01e",
      "shopwareAccessKey": "SWSCAENHRFNOCNL4UUVKEJV3UG",
      "domain": "wetrok.pl",
      "domainDefault": true,
      "files": [
        "lang/pl.json"
      ]
    },
    {
      "code": "pl_en",
      "name": "English (Poland)",
      "display": "English",
      "iso": "en-US",
      "group": "pl",
      "perfionCulture": "en-US",
      "shopwareLangId": "0196aefc56c17f0ab6270425d926a309",
      "shopwareAccessKey": "SWSCAENHRFNOCNL4UUVKEJV3UG",
      "domain": "wetrok.pl",
      "files": [
        "lang/en.json"
      ]
    }
  ],
  "defaultLocale": "ch_de",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": true,
  "langDir": "lang/",
  "detectBrowserLanguage": false,
  "differentDomains": true,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ch_de",
    "name": "Deutsch (Schweiz)",
    "display": "Deutsch",
    "iso": "de-CH",
    "group": "ch",
    "perfionCulture": "de-DE",
    "shopwareLangId": "0196aefcaad978baa1a22d25a9f0cf82",
    "shopwareAccessKey": "SWSCWNHOBEIWNDUWOGKXEGW0AQ",
    "domain": "wetrok.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "lang/de.json"
      }
    ]
  },
  {
    "code": "ch_fr",
    "name": "Français (Suisse)",
    "display": "Français",
    "iso": "fr-CH",
    "group": "ch",
    "shopwareLangId": "0196af04d70f76e89fc7e0c924024f7e",
    "perfionCulture": "fr-FR",
    "shopwareAccessKey": "SWSCWNHOBEIWNDUWOGKXEGW0AQ",
    "domain": "wetrok.ch",
    "files": [
      {
        "path": "lang/fr.json"
      }
    ]
  },
  {
    "code": "ch_it",
    "name": "Italiano (Svizzera)",
    "display": "Italiano",
    "iso": "it-CH",
    "group": "ch",
    "perfionCulture": "en-US",
    "shopwareLangId": "0196af05544f7d7ab0a7526778268574",
    "shopwareAccessKey": "SWSCWNHOBEIWNDUWOGKXEGW0AQ",
    "domain": "wetrok.ch",
    "files": [
      {
        "path": "lang/it.json"
      }
    ]
  },
  {
    "code": "ch_en",
    "name": "English (Switzerland)",
    "display": "English",
    "iso": "en-US",
    "group": "ch",
    "perfionCulture": "en-US",
    "shopwareLangId": "0196aefaa5d17b01b967c289591d9a78",
    "shopwareAccessKey": "SWSCWNHOBEIWNDUWOGKXEGW0AQ",
    "domain": "wetrok.ch",
    "files": [
      {
        "path": "lang/en.json"
      }
    ]
  },
  {
    "code": "at_de",
    "name": "Deutsch (Österreich)",
    "display": "Deutsch",
    "iso": "de-AT",
    "group": "at",
    "perfionCulture": "de-DE",
    "shopwareLangId": "0196aefd33da79f893a78859a8ec5939",
    "shopwareAccessKey": "SWSCMWDFNTD2EXDKNFZ2UUXXEQ",
    "domain": "wetrok.at",
    "domainDefault": true,
    "files": [
      {
        "path": "lang/de.json"
      }
    ]
  },
  {
    "code": "at_en",
    "name": "English (Austria)",
    "display": "English",
    "iso": "en-US",
    "group": "at",
    "perfionCulture": "en-US",
    "shopwareLangId": "0196aefb8c26710b9bdf2e59925c22c7",
    "shopwareAccessKey": "SWSCMWDFNTD2EXDKNFZ2UUXXEQ",
    "domain": "wetrok.at",
    "files": [
      {
        "path": "lang/en.json"
      }
    ]
  },
  {
    "code": "de_de",
    "name": "Deutsch (Deutschland)",
    "display": "Deutsch",
    "iso": "de-DE",
    "group": "de",
    "shopwareLangId": "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
    "perfionCulture": "de-DE",
    "shopwareAccessKey": "SWSCDZJ5U3HHV2TLZE44UGPNEG",
    "domain": "wetrok.de",
    "domainDefault": true,
    "files": [
      {
        "path": "lang/de.json"
      }
    ]
  },
  {
    "code": "de_en",
    "name": "English (Germany)",
    "display": "English",
    "iso": "en-US",
    "group": "de",
    "perfionCulture": "en-US",
    "shopwareLangId": "0196aefb44f37cb7a41af7abde9419a7",
    "shopwareAccessKey": "SWSCDZJ5U3HHV2TLZE44UGPNEG",
    "domain": "wetrok.de",
    "files": [
      {
        "path": "lang/en.json"
      }
    ]
  },
  {
    "code": "se_sv",
    "name": "Svenska (Sverige)",
    "display": "Svenska",
    "iso": "sv-SE",
    "group": "se",
    "shopwareLangId": "0195cc650fb27124bfc593144c13e9fb",
    "perfionCulture": "en-US",
    "shopwareAccessKey": "SWSCCHLUUNBORFJUTXHOBKV2OA",
    "domain": "wetrok.se",
    "domainDefault": true,
    "files": [
      {
        "path": "lang/sv.json"
      }
    ]
  },
  {
    "code": "se_en",
    "name": "English (Sweden)",
    "display": "English",
    "iso": "en-US",
    "group": "se",
    "shopwareLangId": "0196aefc155c750c9f7f30c63bb3cb44",
    "perfionCulture": "en-US",
    "shopwareAccessKey": "SWSCCHLUUNBORFJUTXHOBKV2OA",
    "domain": "wetrok.se",
    "files": [
      {
        "path": "lang/en.json"
      }
    ]
  },
  {
    "code": "pl_pl",
    "name": "Polski (Polska)",
    "display": "Polski",
    "iso": "pl-PL",
    "group": "pl",
    "perfionCulture": "de-DE",
    "shopwareLangId": "0195cc69c9b1713b829056d4a58bd01e",
    "shopwareAccessKey": "SWSCAENHRFNOCNL4UUVKEJV3UG",
    "domain": "wetrok.pl",
    "domainDefault": true,
    "files": [
      {
        "path": "lang/pl.json"
      }
    ]
  },
  {
    "code": "pl_en",
    "name": "English (Poland)",
    "display": "English",
    "iso": "en-US",
    "group": "pl",
    "perfionCulture": "en-US",
    "shopwareLangId": "0196aefc56c17f0ab6270425d926a309",
    "shopwareAccessKey": "SWSCAENHRFNOCNL4UUVKEJV3UG",
    "domain": "wetrok.pl",
    "files": [
      {
        "path": "lang/en.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
